import { render, staticRenderFns } from "./HistoryPoint.vue?vue&type=template&id=306bdcdd&"
import script from "./HistoryPoint.vue?vue&type=script&lang=js&"
export * from "./HistoryPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoryPoint.vue"
export default component.exports